import { render, staticRenderFns } from "./JointClientFormInput.vue?vue&type=template&id=45d2ccd6&scoped=true"
import script from "./JointClientFormInput.vue?vue&type=script&lang=js"
export * from "./JointClientFormInput.vue?vue&type=script&lang=js"
import style0 from "./JointClientFormInput.vue?vue&type=style&index=0&id=45d2ccd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d2ccd6",
  null
  
)

export default component.exports